// @flow

import React from "react";
import type { ResultItemContainerProps } from "../../../utils/_types";
import CategorizationSlot from "../ItemSlots/CategorizationSlot";
import ImageSlot from "../ItemSlots/ImageSlot";

import { format } from "date-fns";

const NewsItem = ({ result, translations }: ResultItemContainerProps) => {
  const {
    title,
    "@id": url,
    effective,
    description,
    image,
    news_category,
  } = result;
  const effectiveDate = effective
    ? format(new Date(effective), "dd/MM/yyyy")
    : "";
  const keepReadingLabel = translations
    ? translations.keep_reading_label
    : "Keep reading";

  return (
    <div className="result-item">
      <ImageSlot image={image} />
      <div className="data">
        <div className="info">
          <CategorizationSlot category={news_category} />

          {effectiveDate ? (
            <div className="date">
              <i className="fas fa-calendar-alt" /> {effectiveDate}
            </div>
          ) : (
            ""
          )}
        </div>
        <h3>{title}</h3>
        {description.length ? <p className="description">{description}</p> : ""}
        <p className="keep-reading">
          <a href={url} title={keepReadingLabel}>
            {keepReadingLabel} <i className="fas fa-angle-right" />
          </a>
        </p>
      </div>
    </div>
  );
};

export default NewsItem;
